import { QChain, QEq, QMulti, QSingle, QList } from './gen';
import { GenData } from './gen-data';

export const IGenEqSymbol = Symbol('GenEq');
export const IGenSingleSymbol = Symbol('GenSingle');
export const IGenMultiSymbol = Symbol('GenMulti');
export const IGenChainSymbol = Symbol('GenChain');
export const IGenListSymbol = Symbol('GenList');

export interface IGenEq {
  generate(data: GenData): QEq;
}

export interface IGenSingle {
  generate(data: GenData): QSingle;
}

export interface IGenMulti {
  generate(data: GenData): QMulti;
}

export interface IGenChain {
  generate(data: GenData): QChain;
}

export interface IGenList {
  generate(data: GenData): QList;
}

export interface IArchiveUrls {
  getRequiredArchiveUrls(): string[];
}
